
import React from 'react';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';

interface ErrorStateProps {
  error: string;
  onGoHome: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onGoHome }) => (
  <div className="flex items-center justify-center min-h-screen w-full px-4">
    <Card className="max-w-md w-full">
      <CardHeader>
        <CardTitle className="text-red-500 flex items-center gap-2">
          <XCircle />
          Invalid Invitation
        </CardTitle>
        <CardDescription>
          {error}
        </CardDescription>
      </CardHeader>
      <CardFooter>
        <Button onClick={onGoHome} className="w-full">
          Go to Home Page
        </Button>
      </CardFooter>
    </Card>
  </div>
);
